import classNames from 'classnames';
import React, { forwardRef } from 'react';
// Note: Icon CSS is served up via the icons.global.css file;

/**
 * Method to determine if React component is a `Icon` or component.
 * @returns boolean - true implies that it is `Icon`, based on `displayName`
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isIcon = element => {
  var _element$type;

  const validIconDisplayNames = ['Icon', 'UDIconFile'];
  return validIconDisplayNames.includes(element === null || element === void 0 ? void 0 : (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type.displayName);
};
/** Various sizes allowed for Iconography */

const displayName = 'Icon'; // $$udType is still required for older components calling `instanceOfComponent` in `@udemy/shared-utils`;

const $$udType = 'Icon'; // Glyphs in this list will be automatically flipped horizontally
// when writing direction is right-to-left

export const biDirectionalGlyphs = ['next', 'previous'];
/**
 * ### Icon component
 *
 * Renders an inline SVG icon.
 */

const IconComponent = /*#__PURE__*/forwardRef((_ref, iconRef) => {
  let {
    color = 'neutral',
    size = 'small',
    ignoreDirection = false,
    label,
    glyph,
    className,
    ...props
  } = _ref;
  const colorClass = color === 'inherit' ? null : `ud-icon-color-${color}`;
  const isBiDirectional = biDirectionalGlyphs.includes(glyph) && !ignoreDirection;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "aria-hidden": label === false ? true : undefined,
    "aria-label": label === false ? undefined : label,
    role: label === false ? undefined : 'img',
    focusable: "false"
  }, props, {
    className: classNames('ud-icon', `ud-icon-${size}`, colorClass, className, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'ud-icon-bi-directional': isBiDirectional
    }),
    ref: iconRef
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: `#icon-${glyph}`
  }));
});
export const Icon = Object.assign(IconComponent, {
  displayName,
  $$udType
});
//# sourceMappingURL=icon.react-component.js.map